import { AppUserInfo } from 'data/entities/entities';
import { LogManager } from 'aurelia-framework';
import { Logger } from 'aurelia-logging';
import { AppUserInfoService } from 'data/service/app-user-info-service';
import { autoinject } from 'aurelia-dependency-injection';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';
import { MetadataService } from 'data/service/meta-data-service';

@autoinject()
export class SettingsViewModel {

	appUserInfo: AppUserInfo;
	logger:Logger = LogManager.getLogger("SettingsViewModel");
    alertMessage: string;

	constructor(
		private appUserInfoService: AppUserInfoService,
		private metadataService: MetadataService,
		private eventAggregator: EventAggregator) { }

	
	async activate() {
		this.logger.info("Activate");
		this.appUserInfo = await this.appUserInfoService.getCurrentAppUserInfo();
	}
	

	async save() {
		this.logger.info("Save()");
		$("#saveButton").attr("disabled", "true");
		this.eventAggregator.publish(AppEvents.HideHelpSettingChanged, this.appUserInfo.hideHelp);
		this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, true);
		try {
			await this.appUserInfo.save();
			this.alertMessage = "Successfully saved settings";		
		}
		catch (error) {
			this.alertMessage = "There was a problem saving your settings: " + error;
		}
		this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, false);
		this.setMessageTimeout();
		$("#saveButton").attr("disabled", "false");
	}
	setMessageTimeout() {
		window.setTimeout(() => this.alertMessage = '', 3000);
	}


}